export default __webpack_public_path__ + "static/media/tacticattack.273f4e1a.png";